import { Command } from 'cmdk';

import { SupplierGroupMessage } from '../../../../../types/SupplierGroupMessage';
import { Text } from '../../../../cdl/Text/Text';
import { useSupplierList } from '../../../../group/supplier/detail/hooks/useSupplierList';
import { formatCompanyName } from '../../../helpers/formatCompanyName.helper';
import { IconCornerDownRight } from '../../../icons/cdl/CornerDownRight';
import { GroupContextType } from '../../../utils/groupContextType';
import { useGroupContextSelectionHandler } from '../../hooks/useGroupContextSelectionHandler';
import { CommandItem } from '../CommandItem';

interface GroupDetailProps {
    supplierGroup: SupplierGroupMessage;
}

export const GroupContextSupplierGroupDetail = (props: GroupDetailProps) => {
    const suppliersQuery = useSupplierList({ groupId: props.supplierGroup.id });
    const { selectGroup, selectCompany } = useGroupContextSelectionHandler();

    return (
        <Command.Group style={{ minWidth: 0 }}>
            <CommandItem
                value={`group-${props.supplierGroup.id}`}
                onSelect={() => {
                    void selectGroup({ groupId: props.supplierGroup.id, type: GroupContextType.SUPPLIER_GROUP });
                }}
            >
                <Text fontWeight="bold">{props.supplierGroup.name}</Text>
            </CommandItem>
            {suppliersQuery.data?.map((supplier) => (
                <CommandItem
                    key={supplier.id}
                    value={`group-${props.supplierGroup.id}-${supplier.id}`}
                    Icon={IconCornerDownRight}
                    onSelect={() => {
                        void selectCompany({
                            companyId: supplier.id,
                            groupId: supplier.supplierGroupId,
                            type: GroupContextType.SUPPLIER_COMPANY,
                        });
                    }}
                >
                    {formatCompanyName({ company: supplier })}
                </CommandItem>
            ))}
            <Command.Separator alwaysRender />
        </Command.Group>
    );
};
